export enum TipoAtendimentoPainelChamadaEnum {
  ACOLHIMENTO = 'ACOLHIMENTO',
  ATENDIMENTO = 'ATENDIMENTO',
}

export interface AtendimentoPainelChamadaModel {
  id: ID
  cidadao: {
    nome: string
    nomeSocial?: string | null
  }
}

export interface ChamarCidadaoPainelChamadaModel {
  atendimentoId: ID
  tipoAtendimento: TipoAtendimentoPainelChamadaEnum
  sala: { id: ID; label: string }
}

export interface SalaUnidadeSaude {
  readonly id: string
  readonly nome: string
}
